export default {
  cognitoSub(state) {
    return state.cognitoSub;
  },
  userId(state) {
    return state.userId;
  },
  idToken(state) {
    return state.idToken;
  },
  session(state) {
    return state.session;
  },
  refreshToken(state) {
    return state.refreshToken;
  },
  accessToken(state) {
    return state.accessToken;
  },
  isAuthenticated(state) {
    return state.isAuthenticated;
  },
  email(state) {
    return state.email;
  },
  didAutoLogout(state) {
    return state.didAutoLogout;
  },
  givenName(state) {
    return state.givenName;
  },
  familyName(state) {
    return state.familyName;
  },
  companyName(state) {
    return state.companyName;
  },
  companyCode(state) {
    return state.companyCode;
  },
};
